import React, {Component} from "react";
import {connect} from "react-redux";
import {startLoader, setPassword, setPasswordError} from "../../data/actionCreators";
import {message, Spin} from "antd";
import {SetPasswordContainer} from "./SetPasswordContainer";
import {setPasswordErrorMessage} from "../../helpers/error";

const mapStateToProps = (dataStore) => ({
    ...dataStore
});

const mapDispatchToProps = dispatch => ({
    setPassword: (data, history, onSuccess) => {
        dispatch(startLoader());
        dispatch(setPassword(data, (response)=> {
            if (response.data.changed) {
                message.success('Hasło zostało zmienione');
            }
            onSuccess();
            history.push('/login');
        }, (error) => {
            dispatch(setPasswordError(error));
            setPasswordErrorMessage(error);
        }));
    }
});

export const SetPasswordConnector = connect(mapStateToProps, mapDispatchToProps)(
    class extends Component {
        render() {
            return <Spin spinning={this.props.loading}>
                <SetPasswordContainer {...this.props}/>
            </Spin>
        }
    }
);
